import React from 'react';
import styled from 'styled-components';
import media from 'client/styles/media';

import PaddingContainer from './PaddingContainer';

import MainBanner from './MainBanner';
import AnchorMenu from './AnchorMenu';
import Connections from './Connections';
import Supporters from './Supporters';
import BackupMenu from './BackupMenu';
import AllInOne from './AllInOne';
import Personalized from './Personalized';
import Growth from './Growth';
import HowDiffers from './HowDiffers';
import Team from './Team';
import FeatureRequest from './FeatureRequest';

const MainWrap = styled.main`
  width: 100%;
  overflow: hidden;

  .pink-highlight {
    white-space: nowrap;
    background: url(https://static.introwise.com/images/elements/main/pink_highlight.svg) no-repeat;
    -webkit-background-size: 100% 100%;
    background-size: 100% 100%;
    padding: 0 10px 0 5px;
    margin-left: -5px;
  }
`;

const BottomFeatureRequest = styled(PaddingContainer)`
  ${media.md} {
    display: none;
  }
`;

const MainNewNew = () => (
  <MainWrap>
    <MainBanner />
    <AnchorMenu />
    <Connections />
    <Supporters />
    <AllInOne />
    <Personalized />
    <HowDiffers />
    <Growth />
    <Team />
    <BackupMenu />

    <BottomFeatureRequest>
      <FeatureRequest />
    </BottomFeatureRequest>
  </MainWrap>
);

export default MainNewNew;
